import { Controller } from "@hotwired/stimulus"

import { localStorage } from "@/helpers/storage"

export default class extends Controller {
  static targets = ["loginSection", "logoutSection", "profileMenuButton", "userName"]

  declare readonly loginSectionTargets: HTMLElement[]
  declare readonly logoutSectionTarget: HTMLElement
  declare readonly profileMenuButtonTarget: HTMLButtonElement
  declare readonly userNameTarget: HTMLElement

  connect(): void {
    try {
      const user = JSON.parse(localStorage?.getItem("user") || "{}")

      if (Object.hasOwn(user, "firstName")) {
        this.profileMenuButtonTarget.hidden = false
        this.loginSectionTargets.forEach((target) => (target.hidden = true))
        this.logoutSectionTarget.hidden = false

        const { firstName } = user

        if (firstName) {
          this.profileMenuButtonTarget.textContent = firstName.charAt(0)
          this.userNameTarget.textContent = firstName
        }
      }
    } catch (_) {
      // Ignore errors
    }
  }
}
